var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"circle"},[_c('div',{staticClass:"circle-text"},[_c('div',{staticClass:"circle-title"},[_vm._v("Missing")]),_c('div',{staticClass:"circle-ctx"},[_vm._v("The page you were looking for could not be found.")])])])])
}]

export { render, staticRenderFns }